// Picture Record Class (from database)

import { m } from "@/utils/utils";
import store from "@/store/store";
import * as Utils from "@/utils/utils";

export default class PicRecFromDB {

	constructor(dat) {
		const src			= dat || {};

		// Record
		this.rid		= src.pix_rid		|| 0; 
		this.itemId		= src.pix_item_id	|| "i" + Utils.genWord(4);
		this.artId		= src.art_item_id	|| "a123";
		this.live		= src.live			|| "";
		this.sortKey	= src.sort_key		|| 0;
		this.fileExt	= src.file_ext		|| "";
		this.fileSize	= src.file_size		|| 0;
		this.stage		= src.stage			|| "";
		this.merit		= src.merit			|| "";
		this.origName	= src.orig_name		|| "";
		this.imgName	= src.img_name		|| "";
		this.thmName	= src.thm_name		|| "";
		this.dir		= src.dir			|| "";
		this.title		= src.title			|| "";
		this.credit		= src.credit		|| "";
		this.descr		= src.descr			|| "";
		this.notes		= src.notes			|| "";
		this.dateCre	= src.date_cre		|| "";
		this.dateMod	= src.date_mod		|| "";

		// Join info
		this.artRid		= src.art_rid		|| 0;

		// Calculated info
		this.primary		= false;
		this.step			= "none";
		this.refImage		= null;
		this.testObj		= {
			updTime			:"",
		}

		this.buildUrls();

		// Upload info
		this.type			= "";
		this.rot 			= 0;
		this.imgs			= {
			min:	null, 
			mid:	null, 
			max:	null,
		};
		

	}


	buildUrls = () => {
		const source	= store.getters["api/state"].source;
		this.imgUrl		= source.url + source.doc + this.dir + "/" + this.imgName;
		this.thmUrl		= source.url + source.doc + this.dir + "/" + this.thmName;
	}

	calcPrimary = (mainId) => {
		m("class calcPrimary");
		m("mainId: " + mainId + " itemId: " + this.itemId);
		this.primary = (this.itemId == mainId);	
		m("primary: " + this.primary);
	}

}

